import { HTTP } from '@ionic-native/http';
import { apiServiceConstants } from '../../constants'


function _getHeadersConfig(isPostX = false) {
    let config: any = {};

    // The `signature` header that used to be set here was AES of a timestamp
    // under a key shipped in this bundle, and no service ever read it. See
    // signatureApiService.

    if (!isPostX) {
      config['Accept'] = 'application/json';
      config['Content-Type'] = 'application/json';
    }
    return config;
  }





function post(url: any, params: any) {
    let responseData = HTTP.post(url, params, _getHeadersConfig())
    .then(resp => params.responseType === 'text' ? resp.data : JSON.parse(resp.data),
          err => {
            //   this.storage.errorHandler(err);
          },
    );
    return (responseData);
}

function get(url: any, params: any) {
  let responseData = HTTP.get(url, params, _getHeadersConfig())
  .then(resp => params.responseType === 'text' ? resp.data : JSON.parse(resp.data),
        err => {
          //   this.storage.errorHandler(err);
        },
        
  )
  return (responseData);
}


const processAPI = (url: String, params: any, method: String) => {

  let result = new Promise(() => { });
  switch (method) {
      case apiServiceConstants.GET: {
          result = get(url, params)
          break;
      }
      case apiServiceConstants.POST: {
          result = post(url, params)
          break;
      }
      default: break;
  }

  return result;
}

export const nativeApiService = {
  post,
  get,
  processAPI
};